import { render, staticRenderFns } from "./ConfirmarDesvincularCandidatoDialogComponent.vue?vue&type=template&id=26a58727"
import script from "./ConfirmarDesvincularCandidatoDialogComponent.vue?vue&type=script&lang=js"
export * from "./ConfirmarDesvincularCandidatoDialogComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports